module.exports = __webpack_public_path__ + "img/WechatIMG190.cc6f1308.png";